// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import React from 'react';

import Svg, { SvgProps } from '../Svg';

const Dashboard: React.FC<SvgProps> = (props) => (
  <Svg {...props} width="24" height="24" viewBox="0 0 24 24">
    <g data-name="グループ 35">
      <g data-name="長方形 74">
        <rect width="10" height="10" rx="1" />
        <rect x=".5" y=".5" width="9" height="9" rx=".5" />
      </g>
      <g data-name="長方形 75" transform="translate(12)">
        <rect width="12" height="16" rx="1" />
        <rect x=".5" y=".5" width="11" height="15" rx=".5" />
      </g>
      <g data-name="長方形 77" transform="translate(0 12)">
        <rect width="10" height="12" rx="1" />
        <rect x=".5" y=".5" width="9" height="11" rx=".5" />
      </g>
      <g data-name="長方形 76" transform="translate(12 18)">
        <rect width="12" height="6" rx="1" />
        <rect x=".5" y=".5" width="11" height="5" rx=".5" />
      </g>
    </g>
  </Svg>
);

Dashboard.displayName = 'Dashboard';

export default Dashboard;
